export default {
  loggedIn: false,
  token: null,
  refreshToken: null,
  user: {},
  profileId: null,
  username: null,
  rolename: null,
  mainFolderId: null,
  userId: null,
  userTenant: null,
  userFeatureFlags: {},
  quickMessages: {},
  loading: false,
  tasks: [],
  notifications: {},
  notificationsGroupedFirstRender: {},
  notificationsSettings: {},
  browserNotifications: true,
  surrogateLogin: false,
}
